module.exports = __webpack_public_path__ + "img/getGift.cb9db828.gif";